// src/components/21.js
import React from 'react';

const Componente21 = () => {
  return (
    <div className="component-container">
      <h2>Número de Propósito: 21</h2>
      <p>
        Para una persona nacida el día 21, el número de propósito asociado sería 21.
      </p>
      <p>
        En numerología, el número 21 está relacionado con la creatividad, la autoexpresión y la alegría. Las personas nacidas en este día suelen ser artísticas y buscan maneras de expresarse y de compartir su creatividad con el mundo. Su propósito puede incluir:
      </p>
      <ul>
        <li><strong>Fomentar la Creatividad:</strong> Estas personas están destinadas a explorar y desarrollar su creatividad en diversas formas, ya sea a través del arte, la escritura o la música.</li>
        <li><strong>Inspirar Alegría:</strong> Su propósito puede incluir traer alegría y positividad a quienes los rodean, convirtiéndose en fuentes de inspiración y felicidad.</li>
        <li><strong>Conectar con Otros:</strong> Tienen una habilidad natural para conectar con los demás a través de su autoexpresión, lo que les permite formar relaciones significativas.</li>
        <li><strong>Promover la Autoexpresión:</strong> Su camino puede involucrar animar a otros a ser auténticos y a expresarse libremente.</li>
      </ul>

      <h3>Características del Día de Nacimiento: 21</h3>
      <ul>
        <li><strong>Artísticos:</strong> Tienen un talento natural para las artes y disfrutan de la creación.</li>
        <li><strong>Optimistas:</strong> Su actitud positiva puede iluminar el día de quienes los rodean.</li>
        <li><strong>Carismáticos:</strong> Su encanto personal y habilidades sociales les permiten atraer a los demás.</li>
      </ul>

      <h4>Resumen</h4>
      <p>
        Las personas nacidas el día 21 son creativas y carismáticas. Su propósito se centra en la autoexpresión y la búsqueda de la alegría, utilizando su talento artístico para inspirar a otros. Su capacidad para conectar con los demás y su optimismo los convierten en faros de luz en la vida de quienes los rodean.
      </p>
    </div>
  );
};

export default Componente21;
